import { Dropdown } from "@curtin-dxp/ui";

export const SemesterSelect = (props) => {
    
    return (
        <Dropdown id={props.id} label={props.label} handleSelection={(e) => props.handleSelection(e, props.id)} options={Semesters(props.sliitCourse)} selection={({value:props.selection})} required={props.required} />
    );
}

function Semesters(sliitCourse) {
    const semesterArray = ["Semester-1 (February)", "Semester-2 (July)"];
    const bachelorOfScienceDataScience = "Bachelor of Science (Data Science) (B-SCNCE)";

    // displaying semester 1 in case if Bachelor of Science (Data Science) (B-SCNCE) is selected
    if (sliitCourse === bachelorOfScienceDataScience) {
        return [{
            value: semesterArray[0]
        }];
    }
    return (
        semesterArray.map((semester) => (
            {
                value: semester
            }
        ))
    );
}